import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoFocus } from 'primeng/autofocus';
import { Checkbox } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { BaseAddPaymentPageLinkComponent } from '../../base/base-add-payment-page-link.component';

@Component({
  selector: 'add-form-payment-page-link-general',
  imports: [
    ToggleSwitch,
    FormsModule,
    InputText,
    NgClass,
    AutoFocus,
    Checkbox
  ],
  templateUrl: './add-form-payment-page-link-general.component.html',
})
export class AddFormPaymentPageLinkGeneralComponent extends BaseAddPaymentPageLinkComponent {

  /**
   * allow only alphanumeric chars and . & - in organisation name
   */
  allowedOrganisationChars: RegExp = /[^a-zA-Z0-9äöüÄÖÜß&.\-\s]/g;

}
